import React from 'react';
import styles from './ProductFeatures.module.scss';
import { Text } from '../../typography/text/Text';
import { containsHTML } from '../../../utils/containsHTML';

export const Feature = ({ item }) => {
  return (
    <div className={styles.feature}>
      {item.imageUrl ? (
        <a href={item.imageUrl} className={styles.image}>
          <img alt={item.title} src={item.image} className={styles.image}/>
        </a>
      ) : (
        <img alt={item.title} src={item.image} className={styles.image}/>
      )}
      <Text
        className={styles.featureTitle}
        as="div"
        weight="bold"
        textTransform="uppercase"
      >
        {item.title}
      </Text>
      <Text className={styles.description} as="div" weight="normal">
        {containsHTML(item.text)
          ? (<span dangerouslySetInnerHTML={{ __html: item.text }} />)
          : item.text
        }
      </Text>
    </div>
  );
};
